;(function() {
  'use strict'

  angular.module('core.faces').factory('facesService', service)

  /* @ngInject */
  function service() {
    var faces = [
      {
        label: 'Very Angry',
        value: 1,
        iconClass: 'gi gi-mood-6',
        colorClass: 'mood-6',
        color: '#e20613',
      },
      {
        label: 'Angry',
        value: 2,
        iconClass: 'gi gi-mood-5',
        colorClass: 'mood-5',
        color: '#f25e5a',
      },
      {
        label: 'Meh',
        value: 3,
        iconClass: 'gi gi-mood-4',
        colorClass: 'mood-4',
        color: '#c8c8c8',
      },
      {
        label: 'Neutral',
        value: 4,
        iconClass: 'gi gi-mood-3',
        colorClass: 'mood-3',
        color: '#f90',
      },
      {
        label: 'Happy',
        value: 5,
        iconClass: 'gi gi-mood-2',
        colorClass: 'mood-2',
        color: '#f6d513',
      },
      {
        label: 'Very Happy',
        value: 6,
        iconClass: 'gi gi-mood-1',
        colorClass: 'mood-1',
        color: '#4cd764',
      },
    ]

    return {
      get: get,
    }

    function get() {
      return _.clone(faces)
    }
  }
})()
